import React from 'react';
import { PapPackingPictureType } from '@ydistri/api-sdk';
import BoxPackingSinglePicture from './BoxPackingSinglePicture';
import { Row } from '@ydistri/ds';

interface BoxPackingPicturesProps {
  calculationId: number;
  sourceStoreId: number;
  targetStoreId: number;
  boxNumber: number;
  packingPictureTypes: PapPackingPictureType[];
}

/**
 * List of images for a single box
 * @param boxNumber
 * @param sourceStoreId
 * @param targetStoreId
 * @param packingPictureTypes
 * @param calculationId
 * @constructor
 */
const BoxPackingPictures: React.FC<BoxPackingPicturesProps> = ({
  boxNumber,
  sourceStoreId,
  targetStoreId,
  packingPictureTypes,
  calculationId,
}) => {
  return (
    <Row $height="74vh" $flexGrow={1} $gap="12px">
      {packingPictureTypes.map((packingPictureType, index) => {
        return (
          <BoxPackingSinglePicture
            boxNumber={boxNumber}
            imageIndex={index}
            calculationId={calculationId}
            sourceStoreId={sourceStoreId}
            targetStoreId={targetStoreId}
            packingPictureType={packingPictureType}
            key={`${boxNumber}-${packingPictureType}`}
          />
        );
      })}
    </Row>
  );
};

export default BoxPackingPictures;
